export const quotations = (state) => state.quotations
export const currentPage = (state) => state.page
export const isSearched = (state) => state.isSearched
export const currentQuotations = (state) => state.currentQuotations
export const isCreated = (state) => state.isCreated
export const status = (state) => state.status
export const currentStates = (state) => state.currentStates
